import * as Yup from 'yup';

const PhoneDigitsRegex = /^[\d\s]+$/;

export const ContactSchema = Yup.object({
    name: Yup.string()
        .trim()
        .min(2, "Ім'я має містити щонайменше 2 символи")
        .matches(/^\p{L}+(?:\s\p{L}+)*$/u, "Ім'я може містити лише літери та пробіли")
        .required("Вкажіть ім'я"),

    countryCode: Yup.string().required('Оберіть код країни'),

    phone: Yup.string()
        .trim()
        .matches(PhoneDigitsRegex, 'Телефон має містити лише цифри і пробіли')
        .test('not-12-digits', 'Телефон не може містити рівно 12 цифр', (val) => {
            if (!val) return true;
            const digits = val.replace(/\s/g, '');
            return digits.length !== 12;
        })
        .required('Вкажіть номер телефону'),

    age: Yup.string()
        .trim()
        .optional()
        .test('is-valid-age', 'Вік має бути числом 0–99', (val) => {
            if (!val) return true;
            const n = Number(val);
            return Number.isInteger(n) && n >= 0 && n <= 99;
        }),

    preferCall: Yup.boolean().default(false),
    preferTelegram: Yup.boolean().default(false),
}).test('one-contact-method', 'Оберіть хоча б один спосіб звʼязку', function (values) {
    const v = values as any;
    if (v.preferCall || v.preferTelegram) return true;
    return this.createError({
        path: 'contactMethod',
        message: 'Оберіть хоча б один спосіб звʼязку',
    });
});
